"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mathScripts = exports.ligatures = exports.ligaturePattern = exports.commands = exports.diacritics = exports.defaultStrings = void 0;
const defaultStrings = {
  jan: '01',
  feb: '02',
  mar: '03',
  apr: '04',
  may: '05',
  jun: '06',
  jul: '07',
  aug: '08',
  sep: '09',
  oct: '10',
  nov: '11',
  dec: '12',
  acmcs: 'ACM Computing Surveys',
  acta: 'Acta Informatica',
  cacm: 'Communications of the ACM',
  ibmjrd: 'IBM Journal of Research and Development',
  ibmsj: 'IBM Systems Journal',
  ieeese: 'IEEE Transactions on Software Engineering',
  ieeetc: 'IEEE Transactions on Computers',
  ieeetcad: 'IEEE Transactions on Computer-Aided Design of Integrated Circuits',
  ipl: 'Information Processing Letters',
  jacm: 'Journal of the ACM',
  jcss: 'Journal of Computer and System Sciences',
  scp: 'Science of Computer Programming',
  sicomp: 'SIAM Journal on Computing',
  tocs: 'ACM Transactions on Computer Systems',
  tods: 'ACM Transactions on Database Systems',
  tog: 'ACM Transactions on Graphics',
  toms: 'ACM Transactions on Mathematical Software',
  toois: 'ACM Transactions on Office Information Systems',
  toplas: 'ACM Transactions on Programming Languages and Systems',
  tcs: 'Theoretical Computer Science'
};
exports.defaultStrings = defaultStrings;
const diacritics = {
  '`': '\u0300',
  "'": '\u0301',
  '^': '\u0302',
  '~': '\u0303',
  '=': '\u0304',
  '"': '\u0308',
  'c': '\u0327',
  'b': '\u0331',
  'u': '\u0306',
  'v': '\u030C',
  '.': '\u0307',
  'd': '\u0323',
  'r': '\u030A',
  'H': '\u030B',
  'k': '\u0328'
};
exports.diacritics = diacritics;
const commands = {
  '~': '\u223C',
  'c\\ ': '\u00B8',
  href: '',
  url: '',
  AE: '\u00C6',
  ae: '\u00E6',
  DH: '\u00D0',
  dh: '\u00F0',
  i: '\u0131',
  j: '\u0237',
  NG: '\u014A',
  ng: '\u014B',
  O: '\u00D8',
  o: '\u00F8',
  OE: '\u0152',
  oe: '\u0153',
  ss: '\u00DF',
  TH: '\u00DE',
  th: '\u00FE',
  copyright: '\u00A9',
  guillemotleft: '\u00AB',
  guillemotright: '\u00BB',
  guilsinglleft: '\u2039',
  guilsinglright: '\u203A',
  quotedblbase: '\u201E',
  quotesinglbase: '\u201A',
  textacutedbl: '\u02DD',
  textasciiacute: '\u00B4',
  textasciicircum: '\u02C6',
  textasciidieresis: '\u00A8',
  textasciimacron: '\u00AF',
  textbardbl: '\u2016',
  textbrokenbar: '\u00A6',
  textbullet: '\u2022',
  textcelsius: '\u2103',
  textcent: '\u00A2',
  textcircledP: '\u2117',
  textcopyright: '\u00A9',
  textdagger: '\u2020',
  textdaggerdbl: '\u2021',
  textdegree: '\u00B0',
  textdiv: '\u00F7',
  textellipsis: '\u2026',
  textemdash: '\u2014',
  textendash: '\u2013',
  textestimated: '\u212E',
  texteuro: '\u20AC',
  textexclamdown: '\u00A1',
  textfractionsolidus: '\u2044',
  textlnot: '\u00AC',
  textmu: '\u00B5',
  textnumero: '\u2116',
  textohm: '\u2126',
  textonehalf: '\u00BD',
  textonequarter: '\u00BC',
  textonesuperior: '\u00B9',
  textordfeminine: '\u00AA',
  textordmasculine: '\u00BA',
  textparagraph: '\u00B6',
  textperiodcentered: '\u00B7',
  textperthousand: '\u2030',
  textpm: '\u00B1',
  textquestiondown: '\u00BF',
  textquotedblleft: '\u201C',
  textquotedblright: '\u201D',
  textquoteleft: '\u2018',
  textquoteright: '\u2019',
  textregistered: '\u00AE',
  textsection: '\u00A7',
  textservicemark: '\u2120',
  textsterling: '\u00A3',
  textthreequarters: '\u00BE',
  textthreesuperior: '\u00B3',
  texttimes: '\u00D7',
  texttrademark: '\u2122',
  texttwosuperior: '\u00B2',
  textunderscore: '\u2017',
  textyen: '\u00A5',
  Gamma: '\u0393',
  Delta: '\u0394',
  Theta: '\u0398',
  Lambda: '\u039B',
  Xi: '\u039E',
  Pi: '\u03A0',
  Sigma: '\u03A3',
  Phi: '\u03A6',
  Psi: '\u03A8',
  Omega: '\u03A9',
  alpha: '\u03B1',
  beta: '\u03B2',
  gamma: '\u03B3',
  delta: '\u03B4',
  varepsilon: '\u03B5',
  zeta: '\u03B6',
  eta: '\u03B7',
  theta: '\u03B8',
  iota: '\u03B9',
  kappa: '\u03BA',
  lambda: '\u03BB',
  mu: '\u03BC',
  nu: '\u03BD',
  xi: '\u03BE',
  pi: '\u03C0',
  rho: '\u03C1',
  varsigma: '\u03C2',
  sigma: '\u03C3',
  tau: '\u03C4',
  upsilon: '\u03C5',
  varphi: '\u03C6',
  chi: '\u03C7',
  psi: '\u03C8',
  omega: '\u03C9',
  vartheta: '\u03D1',
  Upsilon: '\u03D2',
  phi: '\u03D5',
  varpi: '\u03D6',
  varrho: '\u03F1',
  epsilon: '\u03F5'
};
exports.commands = commands;
const ligaturePattern = /---?|'''?|```?|!!|\?!|!\?|\bTEL\b|~/g;
exports.ligaturePattern = ligaturePattern;
const ligatures = {
  '---': '\u2014',
  '--': '\u2013',
  "'''": '\u2034',
  "'": '\u201D',
  '```': '\u2037',
  '``': '\u201C',
  '!!': '\u203C',
  '?!': '\u2048',
  '!?': '\u2049',
  'TEL': '\u2121',
  '~': '\u00A0'
};
exports.ligatures = ligatures;
const mathScripts = {
  '^': {
    '0': '\u2070',
    '1': '\u00B9',
    '2': '\u00B2',
    '3': '\u00B3',
    '4': '\u2074',
    '5': '\u2075',
    '6': '\u2076',
    '7': '\u2077',
    '8': '\u2078',
    '9': '\u2079',
    '+': '\u207A',
    '-': '\u207B',
    '=': '\u207C',
    '(': '\u207D',
    ')': '\u207E',
    'i': '\u2071',
    'n': '\u207F'
  },
  '_': {
    '0': '\u2080',
    '1': '\u2081',
    '2': '\u2082',
    '3': '\u2083',
    '4': '\u2084',
    '5': '\u2085',
    '6': '\u2086',
    '7': '\u2087',
    '8': '\u2088',
    '9': '\u2089',
    '+': '\u208A',
    '-': '\u208B',
    '=': '\u208C',
    '(': '\u208D',
    ')': '\u208E',
    'a': '\u2090',
    'e': '\u2091',
    'o': '\u2092',
    'x': '\u2093',
    '\u0259': '\u2094',
    'h': '\u2095',
    'k': '\u2096',
    'l': '\u2097',
    'm': '\u2098',
    'n': '\u2099',
    's': '\u209A',
    'p': '\u209B',
    't': '\u209C'
  }
};
exports.mathScripts = mathScripts;